export default "__VITE_ASSET__M3qkZQ_U__"